import { createHttpLink } from '@apollo/client';
import fetch from 'node-fetch';

const httpLink = createHttpLink({
  uri: '/api/p/e',
  credentials: 'same-origin',
  fetch,
});

export default httpLink;
